import Vue from 'vue';
import { Config } from '@/models/SmartTable/Config';
import { ITranslation } from '@/models/SmartTable/ITranslation';

export default Vue.extend({
  props: {
    config: {
      type: Object as () => Config,
      required: true
    },
    language: { type: String, default: 'de' }
  },
  computed: {
    currentTranslation(): ITranslation | undefined {
      let loadedTranslation = this.config.translations.find((x) => x.language === this.language);
      if (!loadedTranslation) {
        loadedTranslation = this.config.translations.find((x) => x.language === 'de');
      }
      return loadedTranslation;
    }
  }
});
